import { EnvironmentBannerLayout, NavbarLayout, useTestIds, useToast } from "@homebound/beam";
import { Outlet, useLocation } from "react-router-dom";
import { ErrorBoundary } from "src/components/ErrorBoundary";
import { getBackendStage } from "src/context";
import { useFeatureFlags } from "src/contexts/FeatureFlags/FeatureFlagContext";
import { useCurrentUser } from "src/hooks/useCurrentUser";
import { useStopInternalUserImpersonationMutation } from "src/queries/user.generated";
import { getGlobalNavbarProps } from "src/routes/layout/global-nav/GlobalNav";

export function BeamNavbarLayout() {
  const testIds = useTestIds({}, "globalNav");
  const { name, avatar, user } = useCurrentUser();
  const stage = getBackendStage();
  const isImpersonating = user?.isBeingImpersonated ?? false;
  const { pathname } = useLocation();
  const { featureIsEnabled } = useFeatureFlags();
  const { showToast } = useToast();
  const [stopImpersonation] = useStopInternalUserImpersonationMutation();

  async function handleStopImpersonation() {
    await stopImpersonation();
    window.location.reload();
  }

  const navbarProps = getGlobalNavbarProps(
    name,
    avatar,
    pathname,
    featureIsEnabled,
    handleStopImpersonation,
    isImpersonating,
    showToast,
    testIds,
  );
  return (
    <EnvironmentBannerLayout environmentBanner={{ env: stage, impersonating: isImpersonating ? { name } : undefined }}>
      <NavbarLayout navbar={navbarProps}>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </NavbarLayout>
    </EnvironmentBannerLayout>
  );
}
